import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function Unauthorized() {
  return (
    <>
      <SEO page="unauthorized" />
      <div className="min-h-[40vh] px-4 sm:px-6 md:px-8 py-10">
        <h1 className="text-2xl font-semibold text-primary-text mb-2">Unauthorized</h1>
        <p className="text-secondary-text mb-4">You don’t have permission to view this page.</p>
        <Link to="/" className="cta-brand" data-variant="primary">Go Home</Link>
      </div>
    </>
  );
}